import { render, staticRenderFns } from "./personalV2.vue?vue&type=template&id=0d4b90da&scoped=true"
import script from "./personalV2.vue?vue&type=script&lang=js"
export * from "./personalV2.vue?vue&type=script&lang=js"
import style0 from "./personalV2.vue?vue&type=style&index=0&id=0d4b90da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b90da",
  null
  
)

export default component.exports